export enum GoogleAnalyticsEvents {
    ProductAddToCart = 'product-addtocart',
    ProductRemoveFromCart = 'product-removefromcart',
    ProductCartView = 'product-cartview',
    ProductClick = 'product-click',
    ProductAddToWishlist = "product-addtowishlist",

    ProductDetailImpression = 'product-detail-impression',
    ProductImpression = 'product-impression',
    PageImpression = 'page-impression',
    SectionImpression = 'section-impression',
    ButtonImpression = 'button-impression',
    LinkImpression = 'link-impression',

    ButtonClick = 'button-click',

    ToolStep = 'tool-step',
    ToolStepLast = 'tool-laststep',

    CheckoutStep = 'checkout',
    CheckoutPurchase = 'checkout-purchase',

    BannerClick = "banner-click",
    BannerImpression = "banner-impression",

    LinkClick = "link-click",
    NavigationClick = "navigation-click"

}
